import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SbkFeatureFlagsAndLimitsDataService {
    private featureFlagsAndLimitsServicePath = '/feature-flags-limits-service/limits';
    private apiRoot = '/api';

    constructor(private readonly http: HttpClient) { }

    getFeatureFlagsAndLimits(): Observable<any> {
        const version = 'v1';
        const uri = `${this.apiRoot}${this.featureFlagsAndLimitsServicePath}/client-api/${version}/list-feature-limits`;

        return this.http.get(uri, { headers: { 'X-Limits': 'ety56jgurnsndkmgsz', 'X-handshake': 'ety26mobilety' } });
    }
}
